module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/upgrade-to-2-35.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/upgrade-to-2.md
// module id = 776
// module chunks = 389